var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListCheck = function SvgListCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.547 15.047a.599.599 0 1 1 .848.848l-4 4a.6.6 0 0 1-.848 0l-2-2a.599.599 0 1 1 .848-.848l1.576 1.576zm-9.576 2.824a.6.6 0 1 1 0 1.2h-8a.6.6 0 1 1 0-1.2zm5-7a.6.6 0 1 1 0 1.2h-13a.6.6 0 1 1 0-1.2zm0-7a.6.6 0 1 1 0 1.2h-13a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgListCheck;